module.exports = "<span>\n    <h4>{{context.value | uppercase}}</h4>\n</span>\n<span>\n    <h5 [innerHTML]=\"context.label | uppercase\"></h5>\n</span>"